module.exports = __webpack_public_path__ + "img/Next.27579eb3.svg";